import styled from 'styled-components'

import BodyPortableText, {
  Subheading1,
  Subheading2,
  Subheading3,
  Subheading4,
} from '../../sanity-page/BodyPortableText'

export const AccountBodyPortableText = styled(BodyPortableText)`
  h1,
  h2,
  h3,
  h4,
  h5,
  ${Subheading1}, ${Subheading2}, ${Subheading3}, ${Subheading4} {
    color: unset;
  }

  p,
  ul,
  ol {
    font-size: 15px;
  }
`
